import { openDB, type IDBPDatabase } from 'idb';
import type { OfflineQueueEntry } from '../../domain/repositories/IUploadRepository.js';

const DB_NAME = 'upload_queue';
const STORE = 'queue';
const VERSION = 1;

type QueueRecord = Omit<OfflineQueueEntry, 'createdAt'> & { createdAt: string };

export class UploadQueueLocalDataSource {
  private db: IDBPDatabase | null = null;

  private async getDb(): Promise<IDBPDatabase> {
    if (!this.db) {
      this.db = await openDB(DB_NAME, VERSION, {
        upgrade(db) {
          if (!db.objectStoreNames.contains(STORE)) {
            db.createObjectStore(STORE, { keyPath: 'id' });
          }
        },
      });
    }
    return this.db;
  }

  async enqueue(entry: OfflineQueueEntry): Promise<void> {
    const db = await this.getDb();
    const record: QueueRecord = { ...entry, createdAt: entry.createdAt.toISOString() };
    await db.put(STORE, record);
  }

  async loadAll(): Promise<OfflineQueueEntry[]> {
    const db = await this.getDb();
    const records = await db.getAll(STORE) as QueueRecord[];
    return records.map((r) => ({ ...r, createdAt: new Date(r.createdAt) }));
  }

  async remove(id: string): Promise<void> {
    const db = await this.getDb();
    await db.delete(STORE, id);
  }
}
